<div class="input-group">
  <input
    #searchBox
    type="text"
    class="form-control {{ props.cssClass }}"
    [formlyAttributes]="field"
    [formControl]="$any(formControl)"
    (keyup.enter)="search()"
  />
  <button type="button" class="btn btn-light" (click)="clearSearch(searchBox)">
    <i class="fa fa-times"></i>
  </button>
  <button type="button" class="btn btn-light" (click)="search()">
    <i class="fa fa-search"></i>
  </button>
</div>

@if (options$ | async) {
  <div class="input-group mt-1">
    <ng-select
      i18n-placeholder
      placeholder="Please select..."
      bindValue="value"
      bindLabel="label"
      class="form-control {{ props.cssClass }}"
      [items]="options$ | async"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      (change)="onSelected($event)"
    ></ng-select>
  </div>
}
